import { Module } from 'vuex'
import { LevelUpDayState, CompanyState, RootState } from '../store/state_models'

/*
Usage
-----

In your component/page add a computed variable

computed: {
    isEnabled(){
        return this.$store.getters['LevelUpDayFlag/isfeatursActive']
    }
}
*/

export const LevelUpDayFlag: Module<LevelUpDayState, RootState> = {
  namespaced: true,
  state: {
    featuresActive: false,
    levelupDate: new Date("2024-10-22T10:00:00+05:30")
  },
  getters: {
    isfeatursActive(state: LevelUpDayState, getters: any, rootState: RootState, rootGetters: any){
        return true
    }
  }
}
